import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
import { Page } from '../../Page';

export const FocusModeSkeleton: FC = () => {
  return (
    <Page back={true} insetEnabled={false}>
      <Stack alignItems="center" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
        <ThemedSkeleton variant="text" width={120} height={28} />
      </Stack>
      <Stack 
        flexGrow={1} 
        padding="10px 20px" 
        gap={2} 
        alignItems="center" 
        justifyContent="center"
      >
        <Stack gap={1} width="100%" alignItems="center" justifyContent="center">
            {/* Quest name */}
            <ThemedSkeleton variant="text" width="60%" height={36} sx={{ alignSelf: 'center' }} />
            
            {/* Description */}
            <Stack gap={0.2} width="100%" alignItems="center" justifyContent="center">
                <ThemedSkeleton variant="text" width="80%" height={20} sx={{ alignSelf: 'center' }} />
                <ThemedSkeleton variant="text" width="80%" height={20} sx={{ alignSelf: 'center' }} />
            </Stack>
        </Stack>
        
        {/* Timer */}
        <Stack width="100%" gap={3} direction="row" alignItems="space-between" justifyContent="center">
            <ThemedSkeleton variant="text" width={150} height={80} />
            <ThemedSkeleton variant="text" width={150} height={80} />
        </Stack>
        
        {/* XP and category info */}
        <Stack gap={1} alignItems="center">
          <Stack direction="row" alignItems="center" spacing={1}>
            <ThemedSkeleton variant="text" width={75} height={45} />
          </Stack>
          <Stack direction="row" alignItems="center" spacing={1}>
            <ThemedSkeleton variant="text" width={120} height={30} />
          </Stack>
        </Stack>
        
        {/* Complete button */}
        <ThemedSkeleton variant="rectangular" width={200} height={50} sx={{ borderRadius: '12px', marginTop: 2 }} />
      </Stack>
    </Page>
  );
};

